<template>

  <div class="wscn-http500-container">

    <div class="wscn-http500">
      <div class="bullshit">
        <div class="bullshit__oops">抱歉!</div>

        <div class="bullshit__headline">{{ message }}</div>
        <div class="bullshit__info">如有需要请联系您的领导或者您可以重新登录</div>
        <a href="" class="bullshit__return-home">重新登录</a>
      </div>
      <div class="pic-500">
        <img class="pic-500__parent" src="/images/w-imgs/500_images/500.png" alt="500">
        <img class="pic-500__child mid" src="/images/w-imgs/500_images/500_cloud.png" alt="500">
        <img class="pic-500__child right" src="/images/w-imgs/500_images/500_cloud.png" alt="500">
      </div>
    </div>

  </div>

</template>

<script>

export default {
    name: 'Page500',
    computed: {
        message() {
            return '您没有权限去该页面'
        }
    }
}
</script>

<style lang="scss" scoped>
.wscn-http500-container{
  width: 1000px;
  max-width: 100%;
  margin: 100px auto;
}
.wscn-http500 {
  position: relative;
  padding: 0 50px;

  .pic-500 {
    position: relative;
    float: left;
    width: 434px;
    height: 308px;
    overflow: hidden;
    &__parent {
      width: 100%;
    }
    &__child {
      position: absolute;
      &.left {
        width: 80px;
        top: 17px;
        left: 220px;
        opacity: 0;
        animation-name: cloudLeft;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-delay: 1s;
      }
      &.mid {
        width: 46px;
        top: 10px;
        left: 420px;
        opacity: 0;
        animation-name: cloudMid;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-delay: 1.2s;
      }
      &.right {
        width: 62px;
        top: 100px;
        left: 500px;
        opacity: 0;
        animation-name: cloudRight;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-delay: 1s;
      }
      // @keyframes cloudLeft {
      //   0% {
      //     top: 17px;
      //     left: 220px;
      //     opacity: 0;
      //   }
      //   20% {
      //     top: 33px;
      //     left: 188px;
      //     opacity: 1;
      //   }
      //   80% {
      //     top: 81px;
      //     left: 92px;
      //     opacity: 1;
      //   }
      //   100% {
      //     top: 97px;
      //     left: 60px;
      //     opacity: 0;
      //   }
      // }
      // @keyframes cloudMid {
      //   0% {
      //     top: 10px;
      //     left: 420px;
      //     opacity: 0;
      //   }
      //   20% {
      //     top: 40px;
      //     left: 360px;
      //     opacity: 1;
      //   }
      //   70% {
      //     top: 130px;
      //     left: 180px;
      //     opacity: 1;
      //   }
      //   100% {
      //     top: 160px;
      //     left: 120px;
      //     opacity: 0;
      //   }
      // }
      // @keyframes cloudRight {
      //   0% {
      //     top: 100px;
      //     left: 500px;
      //     opacity: 0;
      //   }
      //   20% {
      //     top: 120px;
      //     left: 460px;
      //     opacity: 1;
      //   }
      //   80% {
      //     top: 180px;
      //     left: 340px;
      //     opacity: 1;
      //   }
      //   100% {
      //     top: 200px;
      //     left: 300px;
      //     opacity: 0;
      //   }
      // }
    }
  }
  .bullshit {
    position: relative;
    float: left;
    width: 320px;
    margin-top: 60px;
    margin-left: 80px;
    overflow: hidden;
    &__oops {
      font-size: 32px;
      font-weight: bold;
      line-height: 40px;
      color: #1482f0;
      opacity: 0;
      margin-bottom: 20px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-fill-mode: forwards;
    }
    &__headline {
      font-size: 20px;
      line-height: 24px;
      color: #222;
      font-weight: bold;
      opacity: 0;
      margin-bottom: 10px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.1s;
      animation-fill-mode: forwards;
    }
    &__info {
      font-size: 13px;
      line-height: 21px;
      color: grey;
      opacity: 0;
      margin-bottom: 20px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.2s;
      animation-fill-mode: forwards;
    }
    &__return-home {
      display: block;
      float: left;
      width: 110px;
      height: 36px;
      background: #1482f0;
      border-radius: 100px;
      text-align: center;
      color: #ffffff;
      opacity: 0;
      font-size: 14px;
      line-height: 36px;
      cursor: pointer;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.3s;
      animation-fill-mode: forwards;
    }
    @keyframes slideUp {
      0% {
        transform: translateY(60px);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
}
</style>
